import { Action } from "./actionRepository";
import * as functionLib from "../lib/domFunctions";
import { addEvent } from "../lib/eventHandler";

export interface BannerParams {
    elementName: string;
    type: any;
    elementCSS: any;
    el: string;
    id: string;
    elementId: string;
    content: string;
    src: string;
    top: boolean;
    bottom: boolean;
}
export class BannerAction implements Action {
    params: BannerParams;
    constructor(params: BannerParams) {
        this.params = params;
    }
    execute() {
        var banner = functionLib.createElement(
            "div",
            { id: "ug-banner" },
            {
                zIndex: "999",
                boxSizing: "boder-box",
                position: "fixed",
                width: "100%",
                height: this.params.elementCSS.height,
                overflow: "hidden",
                padding: "10px",
                display: "block",
                color: "white",
                backgroundColor: "blue",
            },
        );

        var iframe = functionLib.createElement(
            "iframe",
            { id: "ug-iframe", frameborder: 0, border: 0, src: this.params.src },
            { width: "100%", height: "100%", overflow: "auto" },
        );
        var header = functionLib.createElement("h3", { id: "ug-title" }, { margin: "auto" });
        var textNode = document.createTextNode(this.params.content);
        var closebtn = functionLib.createElement(
            "button",
            { id: "ug-close-button" },
            { position: "absolute", top: "10%", left: "70%" },
        );
        closebtn.innerHTML = "CLOSE";

        document.body.appendChild(banner);
        if (this.params.top) {
            banner.style.top = "0";
        } else if (this.params.bottom) {
            banner.style.bottom = "0";
        }
        banner.appendChild(closebtn);
        banner.appendChild(header);
        header.appendChild(textNode);
        banner.appendChild(iframe);

        var btn = document.getElementById("ug-close-button");
        addEvent(btn, "click", () => {
            functionLib.removeElement(this.params.elementId);
        }); //Klicka på knappen för att stänga banner
        addEvent(window, "message", () => {
            functionLib.removeElement(this.params.elementId);
        }); //Skicka input för att stänga banner
    }
}
